import React from 'react';
// import { ImageBaseView } from 'react-native';

const Header = ({alt, ...rest}) => {

  return (
    <img
      {...rest}
      loading="lazy"
      style={{  width: "95%", maxHeight: "65px"  }} 
      alt={alt}
    />
  );
};

Header.defaultProps = {
  alt: "", // Default alt value
};

export default Header;
